import themeConfig from '@configs/themeConfig'
import {createSlice} from '@reduxjs/toolkit'
import {useLayoutStore} from '@src/store/layout'

export const layoutSlice = createSlice({
  initialState: {
    contentWidth: themeConfig.layout.contentWidth,
    footerType: themeConfig.layout.footer.type,
    isRTL: useLayoutStore.getState().getIsRTL(),
    lastLayout: themeConfig.layout.type,
    layout: themeConfig.layout.type,
    menuCollapsed: useLayoutStore.getState().getMenuCollapsed(),
    menuHidden: themeConfig.layout.menu.isHidden,
    navbarColor: themeConfig.layout.navbar.backgroundColor,
    navbarType: themeConfig.layout.navbar.type,
    skin: useLayoutStore.getState().getSkin()
  },
  name: 'layout',
  reducers: {
    handleContentWidth: (state, action) => {
      state.contentWidth = action.payload
    },
    handleFooterType: (state, action) => {
      state.footerType = action.payload
    },
    handleLastLayout: (state, action) => {
      state.lastLayout = action.payload
    },
    handleLayout: (state, action) => {
      state.layout = action.payload
    },
    handleMenuCollapsed: (state, action) => {
      state.menuCollapsed = action.payload
      useLayoutStore.getState().setMenuCollapsed(action.payload)
    },
    handleMenuHidden: (state, action) => {
      state.menuHidden = action.payload
    },
    handleNavbarColor: (state, action) => {
      state.navbarColor = action.payload
    },
    handleNavbarType: (state, action) => {
      state.navbarType = action.payload
    },
    handleRTL: (state, action) => {
      state.isRTL = action.payload
      useLayoutStore.getState().setIsRTL(action.payload)
    },
    handleSkin: (state, action) => {
      state.skin = action.payload
      useLayoutStore.getState().setSkin(action.payload)
    }
  }
})

export const {
  handleContentWidth,
  handleFooterType,
  handleLastLayout,
  handleLayout,
  handleMenuCollapsed,
  handleMenuHidden,
  handleNavbarColor,
  handleNavbarType,
  handleRTL,
  handleSkin
} = layoutSlice.actions

export default layoutSlice.reducer
